import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { CrudType } from '../../../utility/types/CrudType';
import { CrudStatus } from '../../../utility/types/CrudStatus';

const selectLinkById = createSelector(
  [
    (state) => state.linkList.linkList,
    (_state, linkId) => linkId,
  ],
  (linkList, linkId) => linkList.find((link) => parseInt(link.id, 10) === parseInt(linkId, 10)),
);

const selectLinkList = createSelector([
  (state) => state.linkList.linkList,
], (linkList) => linkList);

const selectLinkListCrudStatus = (state) => state.linkList.crudStatus;

const fetchLinkList = createAsyncThunk(
  'linkList/fetchLinkList',
  async (_, { rejectWithValue, getState }) => {
    const { activeSubscriptionId } = getState().session.sessionInformation;
    try {
      return await axios.get(`/links/get-connector-list/${activeSubscriptionId}`);
    } catch (error) {
      return rejectWithValue({
        name: error.name,
        message: error.message,
        data: error.data,
      });
    }
  },
);

const fetchLink = createAsyncThunk(
  'linkList/fetchLink',
  async (linkConnectorId, { rejectWithValue }) => {
    try {
      return await axios.get(`/links/get-connector/${linkConnectorId}`);
    } catch (error) {
      return rejectWithValue({
        name: error.name,
        message: error.message,
        data: error.data,
      });
    }
  },
);

const initialState = {
  linkList: [],
  crudStatus: CrudStatus.IDLE,
  crudType: CrudType.READ,
  error: {},
};

export const linkListSlice = createSlice({
  name: 'linkList',
  initialState,
  reducers: {
    clearLinkListSlice: () => initialState,
    removeLink: (state, action) => {
      state.linkList = [...state.linkList]
        .filter((link) => link.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLink.pending, (state) => {
        state.crudOperation = CrudType.READ;
        state.crudStatus = CrudStatus.PENDING;
        state.error = false;
      })
      .addCase(fetchLink.fulfilled, (state, action) => {
        const { roomAlertLink } = action.payload.data;
        const foundIndex = state.linkList
          .findIndex((l) => l.id === roomAlertLink.id);
        if (foundIndex !== -1) {
          state.linkList.splice(foundIndex, 1, roomAlertLink);
        } else {
          state.linkList.push(roomAlertLink);
        }
        state.crudOperation = CrudType.READ;
        state.crudStatus = CrudStatus.SUCCESS;
        state.error = false;
      })
      .addCase(fetchLink.rejected, (state) => {
        state.crudOperation = CrudType.READ;
        state.crudStatus = CrudStatus.ERROR;
        state.error = true;
      })
      .addCase(fetchLinkList.pending, (state) => {
        state.crudOperation = CrudType.READ;
        state.crudStatus = CrudStatus.PENDING;
      })
      .addCase(fetchLinkList.fulfilled, (state, action) => {
        state.crudStatus = CrudStatus.SUCCESS;
        state.linkList = action.payload.data.connectorInfoList;
        state.crudStatus = CrudStatus.IDLE;
      })
      .addCase(fetchLinkList.rejected, (state, action) => {
        state.crudStatus = CrudStatus.ERROR;
        state.error = [action.payload];
      });
  },
});

const { actions, reducer } = linkListSlice;
export const {
  clearLinkListSlice,
  removeLink,
} = actions;
export {
  fetchLinkList,
  selectLinkList,
  selectLinkListCrudStatus,
  fetchLink,
  selectLinkById,
};
export default reducer;
